import {ParserConfig} from "./config";
import {ParseResponse} from "./extract";
import {post} from "./utils";


interface Error {
    proxy: string
    error: string
}

export interface ProxyFindResult {
    proxy: string,
    errors: Error[]
}

export async function findProxy(url: string): Promise<ProxyFindResult> {
    const resp = await post<{}, any>(`/api/find_proxy?url=${encodeURIComponent(url)}`, {})
    return resp
}
